import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import speedometer from "../../assets/img/speedometer.svg";
import gasolinePump from "../../assets/img/gasoline-pump.svg";
import appstore from "../../assets/img/appstore.png";
import googleplay from "../../assets/img/googleplay.png";
import { useHistory } from "react-router-dom";
import API from "../../Services/BaseService";
import UrCarAction from "./UrCarAction";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";
import AcceptedCars from "../../Container/Carlist/AcceptedCars";
import CarListError from "../FallBackUI/CarListError";
import DealerAction from "../DealerRedux/DealerAction";
import ls from "local-storage";
import odometer from "../../assets/img/miles.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import UrCarBidList from "./../UrCardetails/UrBidlist";
import SealedBidHome from "../UrCardetails/SealedBidHome";
import "bootstrap/dist/css/bootstrap.min.css";
import { OverlayTrigger, Popover, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";
import WebSocketCaller from '../WebSocket/WebSocket';
import { CountContext } from "../Context/Allcontext";

const Carlist = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const dealerData = useSelector((state) => state.DealerReducer.payload);
  const { send } = WebSocketCaller();
  const { webData, recentlyAddedCars, allCars, recentlySoldCars } = useContext(CountContext);

  console.log("check123", dealerData);
  const [isOpenBidList, setisOpenBidList] = useState(false);
  const [feeDetails, setFeeDetails] = useState("");

  const CustomPrevArrow = (props) => (
    <button {...props} className="custom-prev-arrow">
      &lt;
    </button>
  );

  const CustomNextArrow = (props) => (
    <button {...props} className="custom-next-arrow">
      &gt;
    </button>
  );

  async function logedBuyerFees() {
    console.log("inside fn");
    let request = {
      type: "Seller",
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    const state = API.post("fees/condition", request);
    state
      .then((res) => {
        console.log("res", res);
        if (res.data.success === true) {
          setFeeDetails(res.data.data);
        } else {
          setErrors(res.data.error);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  }

  const responsiveSettings = [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 420,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ];

  const [carDetail, setCarDetail] = useState([]);
  const [allcarDetail, setAllCarDetail] = useState([]);
  const [soldcarDetail, setSoldCarDetail] = useState([]);
  const [allCarsMultiAccept, setAllCarsMultiAccept] = useState([]);
  const [allCarMultiAcceptEnable, setAllCarMultiAcceptEnable] = useState(false);
  console.log("setAllCarMultiAcceptEnable flag", allCarMultiAcceptEnable);
  const [allCarAcceptAll, setAllCarsAcceptAll] = useState([]);
  const [allCarAcceptAllEnable, setAllCarAcceptAllEnable] = useState(false);
  console.log("setAllCarAcceptAllEnable flag", allCarAcceptAllEnable);

  const sellerData = useSelector((state) => state.LoginReducer.payload);
  const [carId, setCarId] = useState([]);
  const [highBid, setHighBid] = useState([]);
  const [buyerId, setBuyerId] = useState([]);
  const [buyerDealerId, setBuyerDealerId] = useState([]);
  const [isOpenAccept, setIsOpensAccept] = useState(false);
  const [checkedCars, setCheckedCars] = useState([]);
  console.log("setCheckedCars", checkedCars);
  const [
    recentlyAddedCarMultiAcceptEnable,
    setRecentlyAddedCarMultiAcceptEnable,
  ] = useState(false);
  const [recentlyAddedCarAcceptAllEnable, setRecentlyAddedCarAcceptAllEnable] =
    useState(false);
  const [recentlyAddedcheckedCars, setRecentlyAddedCheckedCars] = useState([]);
  console.log("setCheckedCars1111", recentlyAddedcheckedCars);
  const [recentlyAddedAllcheckedCars, setRecentlyAddedAllCheckedCars] =
    useState([]);
  const [allCarInfo, setAllCarInfo] = useState([]);
  const [carInfo, setcarInfo] = useState();
  const successData = useSelector((state) => state.LoginReducer.payload);
  const [urPostList, setUrPostList] = useState("");
  const [flagFilter, setFalgFilter] = useState(true);
  const [selectSellerId, setselectSellerid] = useState("");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);
  const [recAddFlag, setRecAddFlag] = useState(false);
  const [allCarFlag, setAllCarFlag] = useState(false);
  const [recSoldFlag, setRecSoldFlag] = useState(false);
  const [dealerList, setDealerList] = useState("");
  const [sellerList, setSellerList] = useState("");
  const [dealerId, setDealerId] = useState("");
  const [selectedSellerDetails, setSelectedSellerDetails] = useState("");
  const [transportationCharge, setTransportationCharge] = useState([]);
  const [bidId, setBidId] = useState("");
  const [isOpenCarHistory, setIsOpenCarHistory] = useState(false);
  const [recLoading, setRecLoading] = useState(true);
  const [allLoading, setAllLoading] = useState(true);
  const [soldLoading, setSoldLoading] = useState(true);
  const refreshTimeoutRef = useRef(null);
  useEffect(() => {
    if (recentlyAddedCars && recentlyAddedCars.length > 0) {
      console.log("Updating recently added cars from WebSocket:", recentlyAddedCars);
      setCarDetail(recentlyAddedCars);
      setRecLoading(false);
    }
  }, [recentlyAddedCars]);
  useEffect(() => {
    if (allCars && allCars.length > 0) {
      console.log("Updating all cars from WebSocket:", allCars);
      setAllCarDetail(allCars);
      setAllLoading(false);
    }
  }, [allCars]);
  useEffect(() => {
    if (recentlySoldCars && recentlySoldCars.length > 0) {
      console.log("Updating recently sold cars from WebSocket:", recentlySoldCars);
      setSoldCarDetail(recentlySoldCars);
      setSoldLoading(false);
    }
  }, [recentlySoldCars]);
  const requestCarListsViaWebSocket = useCallback(() => {
    const currentSellerDealerId = dealerData?.seller_dealer_id || sellerData?.seller_dealer_id;
    const currentSellerToken = sellerData?.seller_token;

    if (!currentSellerDealerId || !currentSellerToken) {
      console.log("Missing seller data, skipping WebSocket request");
      return;
    }

    console.log("Requesting car lists via WebSocket");
    send({
      UpdatedData: {
        seller_dealer_id: currentSellerDealerId,
        seller_token: currentSellerToken,
      },
      model: "recentlyAddCarsfilter"
    });

    send({
      UpdatedData: {
        seller_dealer_id: currentSellerDealerId,
        seller_token: currentSellerToken,
      },
      model: "allCarsfilter"
    });

    send({
      UpdatedData: {
        seller_dealer_id: currentSellerDealerId,
        seller_token: currentSellerToken,
      },
      model: "recentlysoldcarsfilter"
    });
  }, [dealerData, sellerData, send]);

  useEffect(() => {
    getDealername();
    logedBuyerFees();
  }, []);

  useEffect(() => {
    getrecentlycar(dealerData);
    getDealername();
  }, [dealerData]);
  useEffect(() => {
    if (sellerData?.seller_dealer_id && sellerData?.seller_token) {
      const timer = setTimeout(() => {
        requestCarListsViaWebSocket();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [sellerData]);

  const togglePopupAccept = () => {
    setIsOpensAccept(!isOpenAccept);
  };

  const getrecentlycar = (data) => {
    let request = {
      seller_dealer_id:
        data == undefined || data === null
          ? sellerData.seller_dealer_id
          : data.seller_dealer_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    API.post("recentlyAddCarsfilter/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setRecLoading(false);
          setCarDetail(res.data?.data);
          getallcar(dealerData);
        } else {
          setErrors(res.data.error);
          setRecAddFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setRecAddFlag(true);
          setRecLoading(false);
        }
      });
  };

  const handleSellerDetailsName = (e) => {
    setDealerId(e.target.value);
    setSelectedSellerDetails(
      dealerList.filter((data) => data.seller_dealer_id == e.target.value)[0]
    );
    const selectedSellerDetails = dealerList.filter(
      (data) => data.seller_dealer_id == e.target.value
    )[0];
    dispatch(DealerAction.searchrequest(selectedSellerDetails));
    setFalgFilter(false);
    const sellerDealerId = selectedSellerDetails.seller_dealer_id;
    const sellerToken = sellerData.seller_token;

    send({
      UpdatedData: {
        seller_dealer_id: sellerDealerId,
        seller_token: sellerToken,
      },
      model: "recentlyAddCarsfilter"
    });

    send({
      UpdatedData: {
        seller_dealer_id: sellerDealerId,
        seller_token: sellerToken,
      },
      model: "allCarsfilter"
    });

    send({
      UpdatedData: {
        seller_dealer_id: sellerDealerId,
        seller_token: sellerToken,
      },
      model: "recentlysoldcarsfilter"
    });
  };

  const getallcar = (data) => {
    let request = {
      seller_dealer_id:
        data == undefined || data === null
          ? sellerData.seller_dealer_id
          : data.seller_dealer_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    API.post("allCarsfilter/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setAllLoading(false);
          setAllCarDetail(res.data.data);
          getsoldcar(dealerData);
        } else {
          setErrors(res.data.error);
          setAllCarFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setAllCarFlag(true);
        }
      });
  };

  const getDealername = (data) => {
    let request = {
      seller_id: successData.seller_id,
      seller_token: successData.seller_token,
    };
    API.post("dealerNameDynamic/condition", request)
      .then((response) => {
        console.log("check the =========check", response.data.data);
        if (response.data.success === true) {
          console.log("check the color value", response.data.data);
          setDealerList(response.data.data);
        } else {
          setErrors(response.data.error.name);
          setErrorFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setErrorFlag(true);
        }
      });
  };

  const getsoldcar = (data) => {
    let request = {
      seller_dealer_id:
        data == undefined || data === null
          ? sellerData.seller_dealer_id
          : data.seller_dealer_id,
      seller_id: sellerData.seller_id,
      seller_token: sellerData.seller_token,
    };
    API.post("recentlysoldcarsfilter/condition", request)
      .then((res) => {
        if (res.data.success === true) {
          setSoldLoading(false);
          setSoldCarDetail(res.data.data);
        } else {
          setErrors(res.data.error);
          setRecSoldFlag(true);
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error);
          setRecSoldFlag(true);
        }
      });
  };

  const addredirectpage = (pathid, seller_dealer_id, seller_data) => {
    dispatch(UrCarAction.sellerid(seller_data));
    history.push({
      pathname: "/cardetails",
      state: {
        backURL: "/carlist",
        id: pathid,
        sellerDealerId: seller_dealer_id,
      },
    });
    ls.set("backredirection", ["/carList"]);
    console.log("sellerDealerId", seller_dealer_id, pathid);
  };

  const rerunCarPage = (pathid, seller_data) => {
    console.log("seller rerun");
    dispatch(UrCarAction.sellerid(seller_data));
    history.push({
      pathname: "/reRunEditdetails",
      state: { backURL: "/carlist", id: pathid },
    });
    ls.set("backredirection", ["/carList"]);
  };

  // const allredirectpage=(pathid,seller_data,transportation_flag,seller_dealer_id)=>{
  //   // console.log("seller_dealer_id+++++",seller_dealer_id)
  //   dispatch(UrCarAction.sellerid(seller_data))
  //   if(soldredirectpage){
  //   // history.push("/cardetails/"+pathid);
  //   history.push({
  //     pathname: "/soldcardetails",
  //     state: {backURL:"/carlist", id:pathid,transportationFlag:transportation_flag,sellerDealerId: seller_dealer_id}
  //     });
  // }
  // else{
  //   history.push({
  //     pathname: "/cardetails",
  //       state: {backURL:"/carlist", id:pathid,sellerDealerId: seller_dealer_id}
  //       });
  // }
  // }

  const allredirectpage = (
    pathid,
    seller_data,
    transportation_flag,
    seller_dealer_id,
    status
  ) => {
    console.log("seller_dealer_id+++++", seller_data);
    dispatch(UrCarAction.sellerid(seller_data));
    if (status === "sold") {
      history.push({
        pathname: "/soldcardetails",
        state: {
          backURL: "/carlist",
          id: pathid,
          transportationFlag: transportation_flag,
          sellerDealerId: seller_dealer_id,
        },
      });
      console.log("soldcardetails");
      ls.set("backredirection", ["/carList"]);
    } else {
      history.push({
        pathname: "/cardetails",
        state: {
          backURL: "/carlist",
          id: pathid,
          sellerDealerId: seller_dealer_id,
        },
      });
      console.log("soldcardetails");
      ls.set("backredirection", ["/carList"]);
    }
  };

  const soldredirectpage = (
    pathid,
    seller_data,
    title_status_name,
    transportation_flag
  ) => {
    dispatch(UrCarAction.sellerid(seller_data));
    history.push({
      pathname: "/soldcardetails",
      state: {
        backURL: "/carlist",
        id: pathid,
        titlesold: title_status_name,
        transportationFlag: transportation_flag,
      },
    });
    ls.set("backredirection", ["/carList"]);
  };

  const MultiAcceptDisable = () => {
    setAllCarMultiAcceptEnable(false);
  };
  const AllAcceptDisable = () => {
    setAllCarAcceptAllEnable(false);
  };
  const viewMoreredirectpage = (pathid) => {
    history.push({
      pathname: "/urcar",
      state: { urcarBack: "/carlist", id: pathid },
    });
    ls.set("backredirection", ["/carList"]);
  };

  const allCarSelectBox = (id, carData) => {
    const newvalue = document.getElementById(id).checked
      ? [...checkedCars, carData]
      : checkedCars.filter((data) => data.carid !== carData.carid);
    setCheckedCars(
      document.getElementById(id).checked
        ? [...checkedCars, carData]
        : checkedCars.filter((data) => data.carid !== carData.carid)
    );
    console.log("---setCheckedCars----", newvalue);
    console.log("allCarSelectBox id====", id);
    console.log(
      "allCarSelectBox value====",
      document.getElementById(id).checked
    );
    console.log("allCarSelectBox carData====", carData);
    console.log("sellerData====", sellerData);
    setCarId(newvalue.map((data) => data.carid));
    setHighBid(newvalue.map((data) => data.high_bid));
    setBuyerId(newvalue.map((data) => data.buyer_dealer_id));
    setBuyerDealerId(newvalue.map((data) => data.buyer_id));
    setTransportationCharge(newvalue.map((data) => data.transportation_charge));
    console.log(
      "====setCarId====",
      newvalue.map((data) => data.carid)
    );

    // return

    // const request=[
    //   {
    //     seller_dealer_id: sellerData.seller_dealer_id,
    //     active: 1,
    //     car_id: carData.car_id,
    //     email:sellerData.email,
    //     password:sellerData.password,
    //     // buyer_dealer_id:props.buyerId,
    //     updatedBy:sellerData.seller_id,
    //     createdBy:sellerData.seller_id,
    //     status: carData.status,
    //     price: carData.high_bid,
    //     buying_proccess:"seller"
    //   }
    // ]

    // sample request
    //   [{
    //     seller_dealer_id:sellerData.seller_dealer_id,
    //       active: 1,
    //       car_id:props.carId,
    //       email:userName,
    //       password:password,
    //       buyer_dealer_id:props.buyerId,
    //       updatedBy:sellerData.seller_id,
    //       createdBy:sellerData.seller_id,
    //       status: "sold",
    //       price:props.highBid,
    //       buying_proccess:"seller"
    // }]

    // API.post('accpectedCars/add', request).then(res=>{

    // }).catch(err => { console.log(err); });
  };

  const AllCarSelectBox = (AllcarsData) => {
    console.log("==AllscarData==", AllcarsData);
    const Allnewsvalue = AllcarsData.filter(
      (data) =>
        data.status !== "sold" &&
        data.high_bid !== "" &&
        data.high_bid !== null &&
        data.high_bid !== undefined &&
        data.high_bid !== 0 &&
        data.isActive !== 0 &&
        data.label_type !== "Sealed Bid Sales"
    );
    console.log("---setAllsCarInfo----", Allnewsvalue);
    setAllCarMultiAcceptEnable(false);
    setAllCarAcceptAllEnable(true);

    setCarId(Allnewsvalue.map((data) => data.carid));
    setHighBid(Allnewsvalue.map((data) => data.high_bid));
    setBuyerId(Allnewsvalue.map((data) => data.buyer_dealer_id));
    setBuyerDealerId(Allnewsvalue.map((data) => data.buyer_id));
    setTransportationCharge(
      Allnewsvalue.map((data) => data.transportation_charge)
    );

    console.log(
      "====setRecentlyAdded--All-- CarId====",
      Allnewsvalue.map((data) => data.carid)
    );
  };

  const RecentlyAddedMultiAcceptDisable = () => {
    setRecentlyAddedCarMultiAcceptEnable(false);
  };
  const RecentlyAddedAllAcceptDisable = () => {
    setRecentlyAddedCarAcceptAllEnable(false);
  };

  const handleSelect = () => {
    setHighBid([]);
    setCarId([]);
    setBuyerId([]);
    setBuyerDealerId([]);
    setTransportationCharge([]);
  };

  const recentlyAddedCarSelectBox = (id, recentlyAddedcarData) => {
    const recentlyAddednewvalue = document.getElementById(id).checked
      ? [...recentlyAddedcheckedCars, recentlyAddedcarData]
      : recentlyAddedcheckedCars.filter(
        (data) => data.carid !== recentlyAddedcarData.carid
      );
    setRecentlyAddedCheckedCars(
      document.getElementById(id).checked
        ? [...recentlyAddedcheckedCars, recentlyAddedcarData]
        : recentlyAddedcheckedCars.filter(
          (data) => data.carid !== recentlyAddedcarData.carid
        )
    );
    console.log("recentlyAddedCarSelectBox id====", id);
    console.log(
      "recentlyAddedCarSelectBox value====",
      document.getElementById(id).checked
    );
    console.log("recentlyAddedCarSelectBox carData====", recentlyAddedcarData);
    setCarId(recentlyAddednewvalue.map((data) => data.carid));
    setHighBid(recentlyAddednewvalue.map((data) => data.high_bid));
    setBuyerId(recentlyAddednewvalue.map((data) => data.buyer_dealer_id));
    setBuyerDealerId(recentlyAddednewvalue.map((data) => data.buyer_id));
    setTransportationCharge(
      recentlyAddednewvalue.map((data) => data.transportation_charge)
    );

    console.log(
      "====setRecentlyAdded CarId====",
      recentlyAddednewvalue.map((data) => data.carid)
    );
  };

  const recentlyAddedAllCarSelectBox = (AllcarData) => {
    console.log("==AllcarData==", AllcarData);
    const Allnewvalue = AllcarData.filter(
      (data) =>
        data.status !== "sold" &&
        data.high_bid !== "" &&
        data.high_bid !== null &&
        data.high_bid !== undefined &&
        data.high_bid !== 0 &&
        data.isActive !== 0 &&
        data.label_type !== "Sealed Bid Sales"
    );
    console.log("---setAllCarInfo----", Allnewvalue);
    setRecentlyAddedCarMultiAcceptEnable(false);
    setRecentlyAddedCarAcceptAllEnable(true);

    setCarId(Allnewvalue.map((data) => data.carid));
    setHighBid(Allnewvalue.map((data) => data.high_bid));
    setBuyerId(Allnewvalue.map((data) => data.buyer_dealer_id));
    setBuyerDealerId(Allnewvalue.map((data) => data.buyer_id));
    setTransportationCharge(
      Allnewvalue.map((data) => data.transportation_charge)
    );

    console.log(
      "====setRecentlyAdded--All-- CarId====",
      Allnewvalue.map((data) => data.carid)
    );
  };

  const togglePopupBidList1 = (data) => {
    setBidId(data);
    togglePopupBidList();
  };

  const togglePopupBidList = () => {
    setisOpenBidList(!isOpenBidList);
  };

  const togglePopupCarHistory1 = (data) => {
    setBidId(data);
    togglePopupCarHistory();
  };

  const togglePopupCarHistory = () => {
    setIsOpenCarHistory(!isOpenCarHistory);
  };

  const [showPopover, setShowPopover] = useState(
    Array(carDetail.length).fill(false)
  );
  const [showPopoverIndex, setShowPopoverIndex] = useState(null);

  const [carPrice, setCarPrice] = useState("");

  const handleBackButtonClick = (index, item) => {
    console.log(item, "item");
    setShowPopoverIndex(index === showPopoverIndex ? null : index);
    setShowPopover((prevShowPopover) => {
      const newShowPopover = [...prevShowPopover];
      newShowPopover[index] = !newShowPopover[index];
      return newShowPopover;
    });
    setCarPrice(item);
  };

  function TotalSellerCharges(data) {
    let total = 0;
    if (Array.isArray(data)) {
      data.forEach((obj) => {
        total +=
          obj.seller_special_fee_amount !== null
            ? obj.seller_special_fee_amount
            : obj.defaultfeeamount;
      });
    }
    return total;
  }

  const getFeeDetails = (maxPrice) => {
    console.log("----fee---", maxPrice);
    return feeDetails.length > 0
      ? feeDetails.filter((data) => {
        const range = data.from_price;
        const rangeOne = data.to_price;
        if (rangeOne !== "up") {
          return (
            Number(range) <= Number(maxPrice) &&
            Number(maxPrice) <= Number(rangeOne)
          );
        } else {
          return Number(range) <= Number(maxPrice);
        }
      })[0]?.fee || 0
      : 0;
  };

  const totalPrice =
    Number(carPrice.high_bid || 0) -
    (Number(getFeeDetails(carPrice?.high_bid || 0)) +
      Number(TotalSellerCharges(carPrice?.sellerfeechargeslist)) +
      Number(carPrice?.bos_car_charges || 0));

  const TotalPriceForHighBid = (item) => {
    const data =
      Number(item.high_bid || 0) -
      (Number(getFeeDetails(item?.high_bid || 0)) +
        Number(TotalSellerCharges(item?.sellerfeechargeslist)) +
        Number(item?.bos_car_charges || 0));
    return data;
  };

  const popover = (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Header as="h3" className="bg-danger text-white">Vehicle Price</Popover.Header>
      <Popover.Body>
        <div class="Vehicle-Pricelist">
          <p>
            Price - <span>$ {carPrice.high_bid || 0}</span>
          </p>
          <p>
            Sell Fee - <span>$ {getFeeDetails(carPrice.high_bid || 0)}</span>
          </p>
          <p>
            Other Charges -{" "}
            <span>$ {TotalSellerCharges(carPrice.sellerfeechargeslist)}</span>
          </p>
          <p>
            Miscellaneous Charges -{" "}
            <span>$ {carPrice.bos_car_charges || 0}</span>
          </p>
          <p>
            Total Price - <span>$ {totalPrice}</span>
          </p>
        </div>
      </Popover.Body>
    </Popover>
  );

  const [showPopover2, setShowPopover2] = useState(
    Array(allcarDetail.length).fill(false)
  );
  const [showPopoverIndex2, setShowPopoverIndex2] = useState(null);

  const [carPrice2, setCarPrice2] = useState("");

  const handleBackButtonClick2 = (index, item) => {
    console.log(item, "item");
    setShowPopoverIndex2(index === showPopoverIndex2 ? null : index);
    setShowPopover2((prevShowPopover) => {
      const newShowPopover2 = [...prevShowPopover];
      newShowPopover2[index] = !newShowPopover2[index];
      return newShowPopover2;
    });
    setCarPrice2(item);
  };

  const totalPrice2 =
    Number(carPrice2.high_bid) -
    (Number(getFeeDetails(carPrice2?.high_bid)) +
      Number(TotalSellerCharges(carPrice2?.sellerfeechargeslist)) +
      Number(carPrice2?.bos_car_charges));

  const popover2 = (
    <Popover id="popover-basic" className="custom-popover">
      <Popover.Header as="h3" className="bg-danger text-white">Vehicle Price</Popover.Header>
      <Popover.Body>
        <div class="Vehicle-Pricelist">
          <p>
            Price - <span>$ {carPrice2.high_bid}</span>
          </p>
          <p>
            Sell Fee - <span>$ {getFeeDetails(carPrice2.high_bid)}</span>
          </p>
          <p>
            Other Charges -{" "}
            <span>$ {carPrice2.bos_sellerothertotalcharges}</span>
          </p>
          <p>
            Other Charges -{" "}
            <span>$ {TotalSellerCharges(carPrice2.sellerfeechargeslist)}</span>
          </p>
          <p>
            Total Price - <span>$ {totalPrice2}</span>
          </p>
        </div>
      </Popover.Body>
    </Popover>
  );

  // clicks outside ibtn close
  const handleOutsideClick = (event) => {
    if (!event.target.closest(".ibtn")) {
      setShowPopoverIndex(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const handleallcarsOutsideClick = (event) => {
    if (!event.target.closest(".ibtn")) {
      setShowPopoverIndex2(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleallcarsOutsideClick);
    return () => {
      document.removeEventListener("click", handleallcarsOutsideClick);
    };
  }, []);

  useEffect(() => {
    return () => {
      if (refreshTimeoutRef.current) {
        clearTimeout(refreshTimeoutRef.current);
      }
    };
  }, []);
  const handleMagnifierMove = (e, imageUrl) => {
    const wrapper = e.currentTarget;
    const lens = wrapper.querySelector('.magnifier-lens');
    if (!lens) return;

    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    lens.style.left = x + 'px';
    lens.style.top = y + 'px';

    const zoom = 2.5;
    const bgW = rect.width * zoom;
    const bgH = rect.height * zoom;
    const lR = lens.offsetWidth / 2;
    const bgX = (x / rect.width) * bgW - lR;
    const bgY = (y / rect.height) * bgH - lR;

    lens.style.backgroundImage = `url('${imageUrl}')`;
    lens.style.backgroundSize = `${bgW}px ${bgH}px`;
    lens.style.backgroundPosition = `-${bgX}px -${bgY}px`;
  };

  const handleMagnifierEnter = (e) => {
    const lens = e.currentTarget.querySelector('.magnifier-lens');
    if (lens) lens.style.display = 'block';
  };

  const handleMagnifierLeave = (e) => {
    const lens = e.currentTarget.querySelector('.magnifier-lens');
    if (lens) lens.style.display = 'none';
  };
  const refreshCarLists = () => {
  setRecLoading(true);
  setAllLoading(true);
  setSoldLoading(true);
  setAllCarMultiAcceptEnable(false);
  setAllCarAcceptAllEnable(false);
  setRecentlyAddedCarMultiAcceptEnable(false);
  setRecentlyAddedCarAcceptAllEnable(false);
  setCheckedCars([]);
  setRecentlyAddedCheckedCars([]);
  getrecentlycar(dealerData); 
};
  return (
    <div>
      <main id="main" class="">
        {recAddFlag === true ? (
          <CarListError error={errors} />
        ) : (
          <div id="recently-added-cars" className="recently-added-cars">
            <div className="container-fluid inner-page-space">
              <div class="common-heading">
                <div className="row">
                  <div className="col-lg-4"></div>
                  <div className="col-lg-4">
                    <div class="title">
                      <p class="inner-title">Recently Added cars</p>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div class="title-dropdown">
                      <select
                        className={`${dealerData != null
                          ? dealerData?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerData?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerData?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerData?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box"
                          : dealerList[0]?.color == "pink"
                            ? "tableRowPink  form-control box"
                            : dealerList[0]?.color == "firered"
                              ? "tableRowFireRed  form-control box"
                              : dealerList[0]?.color == "green"
                                ? "tableRowGreenColor form-control box"
                                : dealerList[0]?.color == "darkred"
                                  ? "tableRowRed1  form-control box"
                                  : " form-control box"
                          }`}
                        id="drop"
                        placeholder=""
                        onChange={handleSellerDetailsName}
                      >
                        {dealerData !== null ? (
                          <option value={null} style={{ display: "none" }}>
                            {dealerData.dealer_name}(
                            {dealerData.seller_dealer_id})
                          </option>
                        ) : (
                          <option value={null} style={{ display: "none" }}>
                            {dealerList[0]?.dealer_name}(
                            {dealerList[0]?.seller_dealer_id})
                          </option>
                        )}
                        {dealerList.length > 0 && (
                          <>
                            {dealerList.map((dealerList) => (
                              <option
                                className={
                                  dealerList?.color == "pink"
                                    ? "tableRowPink  user_name"
                                    : dealerList?.color == "Silver"
                                      ? "tableRowSilver  user_name"
                                      : dealerList?.color == "Orange"
                                        ? "tableRowOrange  user_name"
                                        : dealerList?.color == "Navy blue"
                                          ? "tableRowNavyBlue  user_name"
                                          : dealerList?.color == "firered"
                                            ? "tableRowFireRed  user_name"
                                            : dealerList?.color == "Purple"
                                              ? "tableRowPurple  user_name"
                                              : dealerList?.color == "Yellow"
                                                ? "tableRowYellow1  user_name"
                                                : dealerList?.color == "green"
                                                  ? "tableRowGreenColor user_name"
                                                  : dealerList?.color == "blue"
                                                    ? "tableRowBlue  user_name"
                                                    : dealerList?.color == "darkred"
                                                      ? "tableRowRed1  user_name"
                                                      : dealerList?.color == "black"
                                                        ? "tableRowBlack1 user_name"
                                                        : " user_name"
                                }
                                key={dealerList.seller_dealer_id}
                                value={dealerList.seller_dealer_id}
                              >
                                {dealerList.dealer_name}(
                                {dealerList?.seller_dealer_id})
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              {recLoading ? (
                <Loading />
              ) : (
                <>
                  {carDetail.length > 0 ? (
                    <>
                      <div class="multiAccept">
                        {recentlyAddedCarMultiAcceptEnable == true ? (
                          <span className="multiAcceptGrp">
                            <button
                              onClick={() => {
                                RecentlyAddedMultiAcceptDisable();
                              }}
                            >
                              {" "}
                              Cancel{" "}
                            </button>{" "}
                            <button onClick={() => togglePopupAccept()}>
                              {" "}
                              Accept{" "}
                            </button>{" "}
                          </span>
                        ) : (
                          <button
                            className="multiAcceptbtn"
                            onClick={() => {
                              setRecentlyAddedCarMultiAcceptEnable(true);
                              setRecentlyAddedCarAcceptAllEnable(false);
                              handleSelect();
                            }}
                          >
                            Multi Accept
                          </button>
                        )}
                        {recentlyAddedCarAcceptAllEnable == true ? (
                          <span className="acceptAllGrp">
                            <button
                              onClick={() => RecentlyAddedAllAcceptDisable()}
                            >
                              {" "}
                              Cancel{" "}
                            </button>{" "}
                            <button onClick={() => togglePopupAccept()}>
                              {" "}
                              Accept{" "}
                            </button>{" "}
                          </span>
                        ) : (
                          <button
                            className="acceptAll"
                            onClick={(e) =>
                              recentlyAddedAllCarSelectBox(
                                carDetail.slice(0, 4)
                              )
                            }
                          >
                            Accept All
                          </button>
                        )}
                      </div>

                      <Slider
                        dots={false}
                        infinite={false}
                        speed={500}
                        slidesToShow={4}
                        slidesToScroll={1}
                        prevArrow={<CustomPrevArrow />}
                        nextArrow={<CustomNextArrow />}
                        responsive={responsiveSettings}
                        centerMode={false}
                      >
                        {carDetail.map((item, index) => (
                          <div key={item.carid}>
                            {item.isActive === "1" ? (
                              <div class="car-item ">
                                {/* <div className="custom_checkbox">
                  <input type="checkbox" id="Used Condition"/> 
                  <label for="Used Condition"></label>                 
                </div> */}
                                {item.status == "sold" ||
                                  item.high_bid == "" ||
                                  item.high_bid == null ||
                                  item.high_bid == undefined ||
                                  item.high_bid == 0 ||
                                  item.isActive == 0 ||
                                  item.label_type == "Sealed Bid Sales" ? (
                                  ""
                                ) : (
                                  <div>
                                    {recentlyAddedCarMultiAcceptEnable && (
                                      <div className="custom_checkbox">
                                        <input
                                          type="checkbox"
                                          id={`recentlyAddedCarSelect${index}`}
                                          onClick={(e) =>
                                            recentlyAddedCarSelectBox(
                                              `recentlyAddedCarSelect${index}`,
                                              item
                                            )
                                          }
                                        />
                                        <label
                                          htmlFor={`recentlyAddedCarSelect${index}`}
                                        ></label>
                                      </div>
                                    )}
                                  </div>
                                )}
                                {(item.status == "sold" ||
                                  item.high_bid == "" ||
                                  item.high_bid == null ||
                                  item.high_bid == undefined ||
                                  item.high_bid == 0 ||
                                  item.isActive == 0 ||
                                  item.label_type == "Sealed Bid Sales"
                                  ? ""
                                  : recentlyAddedCarAcceptAllEnable) && (
                                    <div className="custom_checkbox">
                                      <input
                                        type="checkbox"
                                        checked="true"
                                        id={`recentlyAddedCarSelected${index}`}
                                      />
                                      <label
                                        htmlFor={`recentlyAddedCarSelected${index}`}
                                      ></label>
                                    </div>
                                  )}
                                <div
                                  className="carImg-wrapper"
                                  onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                                  onMouseEnter={handleMagnifierEnter}
                                  onMouseLeave={handleMagnifierLeave}
                                >
                                  <img
                                    class="carImg"
                                    alt="..."
                                    onClick={() => {
                                      item.isActive === "1"
                                        ? addredirectpage(
                                          item.carid,
                                          item.seller_dealer_id,
                                          item
                                        )
                                        : rerunCarPage(item.carid, item);
                                    }}
                                    src={item.image}
                                  />
                                  <div className="magnifier-lens" />
                                </div>
                                <div class="cars-content">
                                  <h3>
                                    <a>
                                      {item.year} {item.make} {item.model}
                                    </a>
                                  </h3>

                                  <div class="km-petrol">
                                    <p class="details">
                                      <img src={speedometer} alt="" />
                                      <span>
                                        {item.mileage} {item.mileage_type}
                                      </span>
                                    </p>
                                    {item.fuel_type == "null" ||
                                      item.fuel_type == null ||
                                      item.fuel_type == "" ||
                                      item.fuel_type == "undefined" ||
                                      item.fuel_type == undefined ? (
                                      ""
                                    ) : (
                                      <p class="details">
                                        <img src={gasolinePump} alt="" />
                                        <span>{item.fuel_type}</span>
                                      </p>
                                    )}
                                  </div>

                                  <div className="make-bit">
                                    {item.label_type ===
                                      "Sealed Bid Sales" ? (
                                      <a class="sealedbid">
                                        <span>
                                          {" "}
                                          {item.label_type.substr(0, 10)}
                                        </span>
                                      </a>
                                    ) : (
                                      <a class="makebit">
                                        <span> {item.label_type}</span>
                                      </a>
                                    )}
                                    {item.label_type ===
                                      "Sealed Bid Sales" ? (
                                      <a
                                        class="cars-buy-btns redBtn butnpad"
                                        onClick={() =>
                                          togglePopupCarHistory1(item.carid)
                                        }
                                      >
                                        Bid Details
                                      </a>
                                    ) : (
                                      <a
                                        class="cars-buy-btns redBtn butnpad"
                                        onClick={() =>
                                          togglePopupBidList1(item.carid)
                                        }
                                      >
                                        Bid Details
                                      </a>
                                    )}
                                  </div>
                                  <div class="odometer">
                                    <p class="details">
                                      <img src={odometer} alt="" />
                                      <span>Is Odometer working</span>:&nbsp;
                                      {item.odometer == "null" ||
                                        item.odometer == null ||
                                        item.odometer == "undefined" ||
                                        item.odometer == undefined
                                        ? ""
                                        : item.odometer}
                                    </p>
                                  </div>

                                  {item.sales_type_id == 1 ? (
                                    ""
                                  ) : (
                                    <div class="cars-prices">
                                      {item.min_price == "" ||
                                        item.min_price == undefined ||
                                        item.min_price == null ? (
                                        ""
                                      ) : (
                                        <div class="prices">
                                          <a class="cta-btns highBid">
                                            Minimum Bid :{" "}
                                            <span> $ {item.min_price}</span>
                                          </a>
                                        </div>
                                      )}
                                      {item.max_price == "" ||
                                        item.max_price == undefined ||
                                        item.max_price == null ? (
                                        ""
                                      ) : (
                                        <div class="prices">
                                          <a class="cta-btns SellPrice">
                                            Sell it now :{" "}
                                            <span> $ {item.max_price} </span>
                                          </a>
                                        </div>
                                      )}

                                      {item.high_bid == "" ||
                                        item.high_bid == undefined ||
                                        item.high_bid == null ? (
                                        ""
                                      ) : (
                                        <>
                                          {" "}
                                          <div class="prices">
                                            <a class="cta-btns highBid">
                                              High Bid :{" "}
                                              <span>
                                                {" "}
                                                $ {TotalPriceForHighBid(item)}
                                              </span>
                                            </a>
                                            <OverlayTrigger
                                              trigger="click"
                                              placement="top"
                                              show={
                                                showPopoverIndex === index
                                              }
                                              overlay={popover}
                                            >
                                              <Button
                                                className="ibtn"
                                                onClick={() =>
                                                  handleBackButtonClick(
                                                    index,
                                                    item
                                                  )
                                                }
                                                variant="primary"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faInfo}
                                                />{" "}
                                              </Button>
                                            </OverlayTrigger>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <div class="car-item runout">
                                <div class="runoutOverlay"></div>
                                <img
                                  src={item.image}
                                  class="carImg"
                                  alt="..."
                                />
                                <div class="runoutContent">
                                  <p>Its not running now</p>
                                  <div class="text-center">
                                    <a class="cta-btns runit" href="">
                                      Run it
                                    </a>
                                  </div>
                                </div>
                                <div class="cars-content">
                                  <h3>
                                    <a>
                                      {item.year} {item.make} {item.model}
                                    </a>
                                  </h3>

                                  <div class="km-petrol">
                                    <p class="details">
                                      <img src={speedometer} alt="" />
                                      <span>
                                        {item.mileage} {item.mileage_type}
                                      </span>
                                    </p>
                                    {item.fuel_type == "null" ||
                                      item.fuel_type == null ||
                                      item.fuel_type == "" ||
                                      item.fuel_type == "undefined" ||
                                      item.fuel_type == undefined ? (
                                      ""
                                    ) : (
                                      <p class="details">
                                        <img src={gasolinePump} alt="" />
                                        <span>{item.fuel_type}</span>
                                      </p>
                                    )}
                                  </div>

                                  <div className="make-bit">
                                    {item.label_type ===
                                      "Sealed Bid Sales" ? (
                                      <a class="sealedbid">
                                        <span>
                                          {" "}
                                          {item.label_type.substr(0, 10)}
                                        </span>
                                      </a>
                                    ) : (
                                      <a class="makebit">
                                        <span> {item.label_type}</span>
                                      </a>
                                    )}
                                  </div>

                                  <div class="odometer">
                                    <p class="details">
                                      <img src={odometer} alt="" />
                                      <span>Is Odometer working</span>:&nbsp;
                                      {item.odometer == "null" ||
                                        item.odometer == null ||
                                        item.odometer == "undefined" ||
                                        item.odometer == undefined
                                        ? ""
                                        : item.odometer}
                                    </p>
                                  </div>

                                  <div class="cars-prices">
                                    {item.max_price == "" ||
                                      item.max_price == undefined ||
                                      item.max_price == null ? (
                                      ""
                                    ) : (
                                      <div class="prices">
                                        <a class="cta-btns SellPrice">
                                          Sell it now :{" "}
                                          <span> $ {item.max_price} </span>
                                        </a>
                                      </div>
                                    )}
                                    {item.high_bid == "" ||
                                      item.high_bid == undefined ||
                                      item.high_bid == null ? (
                                      ""
                                    ) : (
                                      <>
                                        <div class="prices">
                                          <a class="cta-btns highBid">
                                            High Bid :{" "}
                                            <span> $ {item.high_bid}</span>
                                          </a>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </Slider>
                    </>
                  ) : (
                    <div class="col-lg-12 nodata">
                      <p>No Data Found</p>{" "}
                    </div>
                  )}

                  {carDetail.length > 4
                    ? carDetail.slice(0, 1).map(() => (
                      <div className="text-center" key="view-more">
                        <a
                          onClick={() => history.push("/recentlyaddedcars")}
                          className="more-btn"
                        >
                          View More <i className="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    ))
                    : ""}
                </>
              )}
            </div>
          </div>
        )}

        {allCarFlag === true ? (
          <CarListError error={errors} />
        ) : (
          <div id="all-cars" class="all-cars">
            <div className="container-fluid inner-page-space">
              <div class="title">
                <p class="inner-title">All cars</p>
              </div>
              {allLoading ? (
                <Loading />
              ) : (
                <>
                  {allcarDetail.length > 0 && (
                    <div class="multiAccept">
                      {allCarMultiAcceptEnable == true ? (
                        <span className="multiAcceptGrp">
                          <button onClick={() => MultiAcceptDisable()}>
                            {" "}
                            Cancel{" "}
                          </button>{" "}
                          <button onClick={() => togglePopupAccept()}>
                            {" "}
                            Accept{" "}
                          </button>{" "}
                        </span>
                      ) : (
                        <button
                          className="multiAcceptbtn"
                          onClick={() => {
                            setAllCarMultiAcceptEnable(true);
                            setAllCarAcceptAllEnable(false);
                          }}
                        >
                          Multi Accept
                        </button>
                      )}
                      {allCarAcceptAllEnable == true ? (
                        <span className="acceptAllGrp">
                          <button onClick={() => AllAcceptDisable()}>
                            {" "}
                            Cancel{" "}
                          </button>{" "}
                          <button onClick={() => togglePopupAccept()}>
                            {" "}
                            Accept{" "}
                          </button>{" "}
                        </span>
                      ) : (
                        <button
                          className="acceptAll"
                          onClick={(e) =>
                            AllCarSelectBox(allcarDetail.slice(0, 4))
                          }
                        >
                          Accept All
                        </button>
                      )}
                    </div>
                  )}
                  {allcarDetail.length > 0 ? (
                    <Slider
                      dots={false}
                      infinite={false}
                      speed={500}
                      slidesToShow={4}
                      slidesToScroll={1}
                      prevArrow={<CustomPrevArrow />}
                      nextArrow={<CustomNextArrow />}
                      responsive={responsiveSettings}
                      centerMode={false}
                    >
                      {allcarDetail.map((item, index) =>
                        item.isActive === "1" ? (
                          <div class="car-item" key={item.carid}>
                            {item.status == "sold" ||
                              item.high_bid == "" ||
                              item.high_bid == null ||
                              item.high_bid == undefined ||
                              item.high_bid == 0 ||
                              item.isActive == 0 ||
                              item.label_type == "Sealed Bid Sales" ? (
                              ""
                            ) : (
                              <div>
                                {allCarMultiAcceptEnable && (
                                  <div className="custom_checkbox">
                                    <input
                                      type="checkbox"
                                      id={`allCarSelect${index}`}
                                      onClick={(e) =>
                                        allCarSelectBox(
                                          `allCarSelect${index}`,
                                          item
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor={`allCarSelect${index}`}
                                    ></label>
                                  </div>
                                )}
                              </div>
                            )}
                            {(item.status == "sold" ||
                              item.high_bid == "" ||
                              item.high_bid == null ||
                              item.high_bid == undefined ||
                              item.high_bid == 0 ||
                              item.isActive == 0 ||
                              item.label_type == "Sealed Bid Sales"
                              ? ""
                              : allCarAcceptAllEnable) && (
                                <div className="custom_checkbox">
                                  <input
                                    type="checkbox"
                                    checked="true"
                                    id={`allCarSelected${index}`}
                                  />
                                  <label htmlFor={`allCarSelected${index}`}></label>
                                </div>
                              )}
                            <div
                              className="carImg-wrapper"
                              onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                              onMouseEnter={handleMagnifierEnter}
                              onMouseLeave={handleMagnifierLeave}
                            >
                              <img
                                class="carImg"
                                src={item.image}
                                onClick={() => {
                                  item.isActive === "1"
                                    ? allredirectpage(
                                      item.carid,
                                      item,
                                      item.transportation_flag,
                                      item.seller_dealer_id,
                                      item.status
                                    )
                                    : rerunCarPage(item.carid, item);
                                }}
                                alt="..."
                              />
                              <div className="magnifier-lens" />
                            </div>
                            <div class="cars-content">
                              <h3>
                                <a>
                                  {item.year} {item.make} {item.model}
                                </a>
                              </h3>

                              <div class="km-petrol">
                                <p class="details">
                                  <img src={speedometer} alt="" />
                                  <span>
                                    {item.mileage} {item.mileage_type}
                                  </span>
                                </p>
                                {item.fuel_type == "null" ||
                                  item.fuel_type == null ||
                                  item.fuel_type == "" ||
                                  item.fuel_type == "undefined" ||
                                  item.fuel_type == undefined ? (
                                  ""
                                ) : (
                                  <p class="details">
                                    <img src={gasolinePump} alt="" />
                                    <span>{item.fuel_type}</span>
                                  </p>
                                )}
                              </div>
                              <div className="make-bit">
                                {item.label_type === "Sealed Bid Sales" ? (
                                  <a class="sealedbid">
                                    <span>
                                      {" "}
                                      {item.label_type.substr(0, 10)}
                                    </span>
                                  </a>
                                ) : (
                                  <a class="makebit">
                                    <span> {item.label_type}</span>
                                  </a>
                                )}
                                {item.label_type === "Sealed Bid Sales" ? (
                                  <a
                                    class="cars-buy-btns redBtn butnpad"
                                    onClick={() =>
                                      togglePopupCarHistory1(item.carid)
                                    }
                                  >
                                    Bid Details
                                  </a>
                                ) : (
                                  <a
                                    class="cars-buy-btns redBtn butnpad"
                                    onClick={() =>
                                      togglePopupBidList1(item.carid)
                                    }
                                  >
                                    Bid Details
                                  </a>
                                )}
                              </div>
                              <div class="odometer">
                                <p class="details">
                                  <img src={odometer} alt="" />
                                  <span>Is Odometer working</span>:&nbsp;
                                  {item.odometer == "null" ||
                                    item.odometer == null ||
                                    item.odometer == "undefined" ||
                                    item.odometer == undefined
                                    ? ""
                                    : item.odometer}
                                </p>
                              </div>
                              {item.status == "sold" ? (
                                <div class="cars-prices">
                                  <div class="prices">
                                    <a class="cta-btns SellPrice">
                                      Sold :{" "}
                                      <span> $ {item.sold_price} </span>
                                    </a>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {item.sales_type_id == 1 ? (
                                    ""
                                  ) : (
                                    <div class="cars-prices">
                                      {item.min_price == "" ||
                                        item.min_price == undefined ||
                                        item.min_price == null ? (
                                        ""
                                      ) : (
                                        <div class="prices">
                                          <a class="cta-btns highBid">
                                            Minimum Bid :{" "}
                                            <span> $ {item.min_price}</span>
                                          </a>
                                        </div>
                                      )}
                                      {item.max_price == "" ||
                                        item.max_price == undefined ||
                                        item.max_price == null ? (
                                        ""
                                      ) : (
                                        <div class="prices">
                                          <a class="cta-btns SellPrice">
                                            Sell it now :{" "}
                                            <span> $ {item.max_price} </span>
                                          </a>
                                        </div>
                                      )}
                                      {item.high_bid == "" ||
                                        item.high_bid == undefined ||
                                        item.high_bid == null ? (
                                        ""
                                      ) : (
                                        <>
                                          <div class="prices">
                                            <a class="cta-btns highBid">
                                              High Bid :{" "}
                                              <span>
                                                {" "}
                                                $ {TotalPriceForHighBid(item)}
                                              </span>
                                            </a>
                                            <OverlayTrigger
                                              trigger="click"
                                              placement="top"
                                              show={
                                                showPopoverIndex2 === index
                                              }
                                              overlay={popover2}
                                            >
                                              <Button
                                                className="ibtn"
                                                onClick={() =>
                                                  handleBackButtonClick2(
                                                    index,
                                                    item
                                                  )
                                                }
                                                variant="primary"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faInfo}
                                                />{" "}
                                              </Button>
                                            </OverlayTrigger>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div
                            class="car-item runout"
                            key={item.carid}
                            onClick={() => {
                              rerunCarPage(item.carid, item);
                            }}
                          >
                            <div class="runoutOverlay"></div>
                            <img src={item.image} class="carImg" alt="..." />
                            <div class="runoutContent">
                              <p>Its not running now</p>
                              <div class="text-center">
                                <a class="cta-btns runit" href="">
                                  Run it
                                </a>{" "}
                              </div>
                            </div>

                            <div class="cars-content">
                              <h3>
                                <a>
                                  {item.year} {item.make} {item.model}
                                </a>
                              </h3>

                              <div class="km-petrol">
                                <p class="details">
                                  <img src={speedometer} alt="" />
                                  <span>
                                    {item.mileage} {item.mileage_type}
                                  </span>
                                </p>
                                {item.fuel_type == "null" ||
                                  item.fuel_type == null ||
                                  item.fuel_type == "" ||
                                  item.fuel_type == "undefined" ||
                                  item.fuel_type == undefined ? (
                                  ""
                                ) : (
                                  <p class="details">
                                    <img src={gasolinePump} alt="" />
                                    <span>{item.fuel_type}</span>
                                  </p>
                                )}
                              </div>
                              <div className="make-bit">
                                {item.label_type === "Sealed Bid Sales" ? (
                                  <a class="sealedbid">
                                    <span>
                                      {" "}
                                      {item.label_type.substr(0, 10)}
                                    </span>
                                  </a>
                                ) : (
                                  <a class="makebit">
                                    <span> {item.label_type}</span>
                                  </a>
                                )}
                              </div>

                              <div class="odometer">
                                <p class="details">
                                  <img src={odometer} alt="" />
                                  <span>Is Odometer working</span>:&nbsp;
                                  {item.odometer == "null" ||
                                    item.odometer == null ||
                                    item.odometer == "undefined" ||
                                    item.odometer == undefined
                                    ? ""
                                    : item.odometer}
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </Slider>
                  ) : (
                    <div class="col-lg-12 nodata">
                      <p>No Data Found</p>{" "}
                    </div>
                  )}

                  {allcarDetail.length > 4
                    ? allcarDetail.slice(0, 1).map(() => (
                      <div className="text-center" key="view-more-all">
                        <a
                          onClick={() => {
                            viewMoreredirectpage();
                          }}
                          class="more-btn"
                        >
                          View More <i class="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    ))
                    : ""}
                </>
              )}
            </div>
          </div>
        )}

        {recSoldFlag === true ? (
          <CarListError error={errors} />
        ) : (
          <div id="recently-sold-cars" class="recently-sold-cars">
            <div className="container-fluid inner-page-space">
              <div class="title">
                <p class="inner-title">Recently Sold cars</p>
              </div>

              {soldLoading ? (
                <Loading />
              ) : (
                <>
                  {soldcarDetail.length > 0 ? (
                    <Slider
                      dots={false}
                      infinite={false}
                      speed={500}
                      slidesToShow={4}
                      slidesToScroll={1}
                      prevArrow={<CustomPrevArrow />}
                      nextArrow={<CustomNextArrow />}
                      responsive={responsiveSettings}
                      centerMode={false}
                    >
                      {soldcarDetail.map((item, index) => (
                        <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6" key={item.carid}>
                          <div class="car-item">
                            <div
                              className="carImg-wrapper"
                              onMouseMove={(e) => handleMagnifierMove(e, item.image)}
                              onMouseEnter={handleMagnifierEnter}
                              onMouseLeave={handleMagnifierLeave}
                            >
                              <img
                                src={item.image}
                                class="carImg"
                                alt="..."
                                onClick={() => {
                                  soldredirectpage(
                                    item.carid,
                                    item,
                                    item.title_status_name,
                                    item.transportation_flag,
                                    item.seller_dealer_id
                                  );
                                }}
                              />
                              <div className="magnifier-lens" />
                            </div>
                            <div class="cars-content">
                              <h3>
                                <a>
                                  {item.year} {item.make} {item.model}
                                </a>
                              </h3>

                              <div class="km-petrol">
                                <p class="details">
                                  <img src={speedometer} alt="" />
                                  <span>
                                    {item.mileage} {item.mileage_type}
                                  </span>
                                </p>
                                {item.fuel_type == "null" ||
                                  item.fuel_type == null ||
                                  item.fuel_type == "" ||
                                  item.fuel_type == "undefined" ||
                                  item.fuel_type == undefined ? (
                                  ""
                                ) : (
                                  <p class="details">
                                    <img src={gasolinePump} alt="" />
                                    <span>{item.fuel_type}</span>
                                  </p>
                                )}
                              </div>
                              <div className="make-bit">
                                {item.label_type === "Sealed Bid Sales" ? (
                                  <a class="sealedbid">
                                    <span>
                                      {" "}
                                      {item.label_type.substr(0, 10)}
                                    </span>
                                  </a>
                                ) : (
                                  <a class="makebit">
                                    <span> {item.label_type}</span>
                                  </a>
                                )}
                                {item.label_type === "Sealed Bid Sales" ? (
                                  <a
                                    class="cars-buy-btns redBtn butnpad"
                                    onClick={() =>
                                      togglePopupCarHistory1(item.carid)
                                    }
                                  >
                                    Bid Details
                                  </a>
                                ) : (
                                  <a
                                    class="cars-buy-btns redBtn butnpad"
                                    onClick={() =>
                                      togglePopupBidList1(item.carid)
                                    }
                                  >
                                    Bid Details
                                  </a>
                                )}
                              </div>

                              <div class="odometer">
                                <p class="details">
                                  <img src={odometer} alt="" />
                                  <span>Is Odometer working</span>:&nbsp;
                                  {item.odometer == "null" ||
                                    item.odometer == null ||
                                    item.odometer == "undefined" ||
                                    item.odometer == undefined
                                    ? ""
                                    : item.odometer}
                                </p>
                              </div>

                              <div class="cars-prices">
                                {item.sold_price == "" ||
                                  item.sold_price == undefined ||
                                  item.sold_price == null ? (
                                  ""
                                ) : (
                                  <div class="prices">
                                    <a class="cta-btns SellPrice">
                                      Sold :{" "}
                                      <span> $ {item.sold_price} </span>
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  ) : (
                    <div class="col-lg-12 nodata">
                      <p>No Data Found</p>{" "}
                    </div>
                  )}

                  {soldcarDetail.length > 4
                    ? soldcarDetail.slice(0, 1).map(() => (
                      <div className="text-center" key="view-more-sold">
                        <a
                          onClick={() => history.push("/recentlysoldcars")}
                          class="more-btn"
                        >
                          View More <i class="bx bx-chevron-right"></i>
                        </a>
                      </div>
                    ))
                    : ""}
                </>
              )}
            </div>
          </div>
        )}

        <section id="playstoreBlock" class="playstoreBlock">
          <div class="container">
            <div class="row content">
              <div class="col-lg-12">
                <img src={appstore} />
                <img src={googleplay} />
              </div>
            </div>
          </div>
        </section>

        {isOpenCarHistory && (
          <Popup
            isClose={false}
            content={
              <>
                <SealedBidHome toggle={togglePopupCarHistory} carId={bidId} />
              </>
            }
            handleClose={togglePopupCarHistory}
          />
        )}
        {isOpenBidList && (
          <Popup
            isClose={false}
            content={
              <>
                <UrCarBidList
                  toggle={togglePopupBidList}
                  carId={bidId}
                />
              </>
            }
            handleClose={togglePopupBidList}
          />
        )}
        {isOpenAccept && (
          <Popup
            isClose={false}
            content={
              <>
                <AcceptedCars
                  toggle={togglePopupAccept}
                  carId={carId}
                  buyerId={buyerId}
                  highBid={highBid}
                  buyerDealerId={buyerDealerId}
                  transportationCharge={transportationCharge}
                  recentlyAddedcheckedCars={recentlyAddedcheckedCars}
                  onSuccess={refreshCarLists}
                />
              </>
            }
            handleClose={togglePopupAccept}
          />
        )}
      </main>
    </div>
  );
};

export default Carlist;